import React from 'react';
import styled from 'styled-components';

// Styled Components
const PageContainer = styled.div`
  padding: 20px;
`;

const Section = styled.section`
  margin-bottom: 40px;
`;

const Header = styled.h1`
  text-align: center;
  margin: 20px 0;
`;

const Subheader = styled.h2`
  color: #333;
`;

const Text = styled.p`
  line-height: 1.6;
`;

const ImagePlaceholder = styled.div`
  width: 100%;
  height: 200px;
  background-color: #ddd;
  text-align: center;
  line-height: 200px; // Example placeholder styling
  margin-bottom: 20px;
`;

const LogoSliderPlaceholder = styled(ImagePlaceholder)`
  height: 100px; // Custom height for logo slider
  line-height: 100px;
`;

// AboutUsPage Component
const AboutUsPage = () => {
  return (
    <PageContainer>
      <Header>About Us</Header>

      <Section>
        <Subheader>Our Vision</Subheader>
        <Text>Our vision is to fundamentally transform the productivity of humanity by harnessing the power of technology.</Text>
      </Section>

      <Section>
        <ImagePlaceholder>
          Visual Representation of Vision
        </ImagePlaceholder>
      </Section>

      <Section>
        <Subheader>Our Story</Subheader>
        <Text>is Founded Inc. was founded by Dan Adika, Rafael Sweary, Eyal Cohen, and Yuval Shalom Ozanna.</Text>
      </Section>

      <Section>
        <LogoSliderPlaceholder>
          Logos Slider Placeholder
        </LogoSliderPlaceholder>
      </Section>

      <Section>
        <Subheader>Awards & Recognition</Subheader>
        <Text>A comprehensive list of awards...</Text>
      </Section>

      <Section>
        <Subheader>Quick Facts</Subheader>
        <Text>8 offices, 750+ employees, 10,000+ companies using ...</Text>
      </Section>

    </PageContainer>
  );
}

export default AboutUsPage;
